/**
 * 🚀 CONFIGURACIÓN GLOBAL DE CACHÉ - Smarty
 * 
 * Este archivo centraliza TODAS las configuraciones de caché del sistema.
 * Modificar aquí afecta el comportamiento de todas las páginas.
 */

// ==================== VERSIONES ====================

/**
 * Versión de IndexedDB
 * Incrementar cuando cambies el schema de IndexedDB
 * 
 * v11: Add tables store for caching restaurant tables
 * v10: Fix useEffect isOnline + reduce threshold to 15s (ultra strict)
 * v9: Freshness threshold validation - only show cache if <1 min old
 * v8: Add fingerprint validation & reduce cache age to 5 min in dev
 * v7: Filter cache by tenant_id to prevent cross-tenant data leaks
 * v6: Force clear all stores on upgrade (fix corrupted cache)
 * v5: Fixed cache replace strategy - clear before saving
 */
export const INDEXEDDB_VERSION = 11;

/**
 * Nombre de la base de datos
 */
export const INDEXEDDB_NAME = 'smarty-offline';

// ==================== TIEMPOS DE SINCRONIZACIÓN ====================

/**
 * Intervalo de auto-sync (milisegundos)
 * Cada cuánto tiempo sincronizar órdenes pendientes
 * 
 * Valores recomendados:
 * - Desarrollo: 10000 (10s)
 * - Producción: 30000 (30s)
 */
export const AUTO_SYNC_INTERVAL = 30000; // 30 segundos

/**
 * Delay entre órdenes al sincronizar (milisegundos)
 * Para no saturar el servidor
 */
export const SYNC_ORDER_DELAY = 500;

/**
 * Máximo número de reintentos por orden
 */
export const MAX_RETRY_ATTEMPTS = 3;

/**
 * Delay para lazy loading de modificadores (milisegundos)
 * Tiempo antes de cargar modificadores en segundo plano
 */
export const MODIFIERS_LAZY_LOAD_DELAY = 100;

// ==================== CONFIGURACIÓN DE RED ====================

/**
 * Timeout para requests de red (milisegundos)
 * Usado por Workbox
 */
export const NETWORK_TIMEOUT = 10000; // 10 segundos

/**
 * Máximo de entradas en caché de Workbox
 */
export const WORKBOX_MAX_ENTRIES = 50;

/**
 * Tiempo de vida del caché de Workbox (segundos)
 */
export const WORKBOX_MAX_AGE_SECONDS = 60 * 60 * 24; // 24 horas

/**
 * 🔥 Tiempo máximo de validez del caché de IndexedDB (horas)
 * Después de este tiempo, el caché se considera inválido
 * 
 * Valores recomendados:
 * - Desarrollo: 0.5 (30 minutos) - Para cambios frecuentes pero usable
 * - Producción: 24 (24 horas) - Para datos estables
 */
export const CACHE_MAX_AGE_HOURS = 0.5; // 30 minutos

/**
 * 🎯 Umbral para mostrar caché INSTANTÁNEAMENTE (minutos)
 * Solo si el caché es más reciente que este valor, se muestra sin loading
 * 
 * Este es el SECRET SAUCE para mejor UX:
 * - Si caché < threshold → Mostrar instantáneamente (super fresco)
 * - Si caché > threshold → Mostrar loading + fetch (puede estar desactualizado)
 * 
 * Valores recomendados:
 * - Desarrollo: 2 (2 minutos) - Balance entre velocidad y frescura
 * - Producción: 5 (5 minutos) - Más agresivo para mejor UX
 * 
 * 🚀 OPTIMIZACIÓN: Threshold de 2 minutos permite caché instantáneo sin parpadeos excesivos
 */
export const CACHE_INSTANT_SHOW_THRESHOLD_MINUTES = 2; // 2 minutos - Balance óptimo
